import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useParams } from 'react-router-dom';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import PartnerDetail from '@app/pages/settings/partner-detail/PartnerDetail.tsx';

const PartnerDetailPage = () => {
  const { id } = useParams();
  const { tr } = useTranslationLgs();

  return (
    <>
      {id && (
        <ResponsiveLayout title={tr(`PartnerDetailPage.PartnerDetail`, `Partner detail`)} oneOfPermission={[PermissionTypesEnum.PERMISSION_SETTINGS_PARTNERS_READ, PermissionTypesEnum.PERMISSION_SETTINGS_PARTNERS_RW]}>
          <PartnerDetail partnerId={id as string}/>
        </ResponsiveLayout>
      )}
    </>
  );
};

export default withAuthenticationRequired(PartnerDetailPage);
